var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 79,
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/document-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.7474 52.083V37.583L39.9141 42.4163",
    stroke: "#FFB07A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.75 37.583L49.5833 42.4163",
    stroke: "#FFB07A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.1654 33.1668V45.2502C69.1654 57.3335 64.332 62.1668 52.2487 62.1668H37.7487C25.6654 62.1668 20.832 57.3335 20.832 45.2502V30.7502C20.832 18.6668 25.6654 13.8335 37.7487 13.8335H49.832",
    stroke: "#FFB07A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M69.1654 33.1668H59.4987C52.2487 33.1668 49.832 30.7502 49.832 23.5002V13.8335L69.1654 33.1668Z",
    stroke: "#FFB07A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 37405"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 371",
    cx: 19,
    cy: 59.5,
    r: 19,
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4362",
    d: "M19 62L19 49",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4363",
    d: "M19 69L19 68",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactAdmin);
export default __webpack_public_path__ + "static/media/contactAdmin.92c1f1efe9d758a07ee56421e070fc19.svg";
export { ForwardRef as ReactComponent };